<template>
  <v-dialog v-model="value" persistent max-width="900px">
        <material-card
          color="orange"
          :title="item.country && item.country.name"
          :text="title"
        >
          <v-form ref="form" v-model="validForm">
            <v-container py-0>
              <v-layout wrap>
              
                <v-flex xs12 md12><br>
                 <ckeditor v-model="item[section]" :config="editorConfig"></ckeditor>
                </v-flex>

                <v-flex md12 text-right>
                  <v-btn color="success" @click="close">Close</v-btn>
                  <v-btn color="purple" class="mx-1 white--text" @click="update">Update</v-btn>
                </v-flex>

              </v-layout>
            </v-container>
          </v-form>
        </material-card>
  </v-dialog>
</template>

<script>

const { put } = require('@/api/base_entity')


export default {
  props: {
    value: { type: Boolean, default: false },
    section: { type: String, default: '' },
    item: { type: Object},
  },
  data: () => ({
    editorConfig: {
      height: 450,
      format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
      toolbar: [['Format', 'Styles', 'Bold', 'Italic', 'Underline', 'SpellChecker', 'Scayt', '-', 'NumberedList', 'BulletedList'],
          ['Link', 'Unlink'], [ '-', 'SelectAll', 'Source']],
    },
    validForm: true
  }),
  watch: {
    value(v) {
      if (v && this.$refs.form) {
        this.$refs.form.reset()
      }
    },
  },
  mounted() {
  },
  computed: {
    title() {
      return this.section.charAt(0).toUpperCase() + this.section.slice(1)
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    update() {
      put('countries_data', this.item.id, {[this.section]: this.item[this.section]}).then( () => {
       
        this.$root.$emit('openSnackbar', {
          message: this.section.toUpperCase() + ' of ' +  this.item.country.name + ' updated correctly',
          color: 'success'
        })

         this.$emit('input', false)
      })
    },
  },
 
}
</script>
